import { StandardLayout } from "../layouts/StandardLayout";

export default function NotFound() {
    let content= <p>Whoops! This page does not exist.</p>
    return <StandardLayout title={"All Posts"} content={content} />;
}
